<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <section style="padding:20px;">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-col>
          <el-form-item label="客户名称:" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">
            <el-select v-model="filters.companyId" filterable clearable placeholder="请选择" @change="companyChange" style="width: 160px;">
              <el-option
                v-for="item in companies" :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域:">
            <el-select v-model="filters.groupId" clearable placeholder="请选择" style="width: 150px;">
              <el-option
                v-for="item in groups" :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备状态:" style="margin-left: 15px;">
            <el-radio-group v-model="filters.type">
              <el-radio :label="null">全部</el-radio>
              <el-radio :label="2">预警</el-radio>
              <el-radio :label="3">告警</el-radio>
              <el-radio :label="4">故障</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="处理状态:" style="margin-left: 15px;">
            <el-radio-group v-model="filters.state">
              <el-radio :label="null">全部</el-radio>
              <el-radio :label="0">未处理</el-radio>
              <el-radio :label="1">已处理</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="float:right">
            <el-form-item>
              <el-button type="primary" v-on:click="handleCurrentChange(0)">查询</el-button>
            </el-form-item>
          </div>
        </el-col>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="events" border highlight-current-row v-loading="listLoading"
              style="width: 100%;">
      <!--<el-table-column-->
              <!--type="index"-->
              <!--width="50">-->
      <!--</el-table-column>-->
      <!--<el-table-column header-align="center" align="center" label="设备ID" min-width="130">-->
        <!--<template scope="scope">-->
          <!--{{scope.row.dtuId}} + {{scope.row.device}}-->
        <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column header-align="center" label="类型" width="80">
        <template scope="scope">
          <el-tag v-if="scope.row.type === 1"
                  type="success"
                  close-transition>{{scope.row.type | filterType}}</el-tag>
          <el-tag v-if="scope.row.type === 2"
                  type="warning"
                  close-transition>{{scope.row.type | filterType}}</el-tag>
          <el-tag v-if="scope.row.type === 3"
                  type="danger"
                  close-transition>{{scope.row.type | filterType}}</el-tag>
          <el-tag v-if="scope.row.type === 4"
                  type="gray"
                  close-transition>{{scope.row.type | filterType}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="deviceName" label="设备名称" min-width="160">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="companyName" label="所属客户"
                       min-width="150">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="groupName" label="区域"
                       min-width="120">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="deviceLocation" label="设备位置"
                       min-width="160">
      </el-table-column>
      <el-table-column header-align="center" prop="content" label="事件记录"
                       min-width="280">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="是否处理"
                       min-width="100">
        <template scope="scope">
          {{scope.row.disposed ? '是': '否'}}
        </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="contactName" label="责任人"
                         min-width="100">
        </el-table-column>
      <el-table-column header-align="center" align="center" prop="contactPhone" label="责任人电话"
                       width="125">
      </el-table-column>
      <el-table-column header-align="center" align="center" :formatter="formatTime" label="事件时间"
                       width="170">
      </el-table-column>
      <el-table-column header-align="center" align="center" :formatter="formatDisposeTime" label="处理时间"
                       width="170">
      </el-table-column>
        <el-table-column header-align="center" align="center" prop="contactPhone" label="操作"
                         width="150">
          <template scope="scope">
            <el-button type="primary" :disabled="scope.row.silent || me.username == 'demo'" size="small" @click="doSilent(scope.$index, scope.row)">消声</el-button>
            <el-button type="danger" :disabled="scope.row.disposed || me.username == 'demo'" size="small" @click="updateState(scope.$index, scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  //import NProgress from 'nprogress'
  import {getEventList,getCompanyList,getGroupList,editState, processSilent} from '../../api/api';

  import moment from 'moment';

  export default {
    data() {
      return {
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        me: JSON.parse(sessionStorage.getItem('user')),
        events: [],
        companies: [],
        groups: [],
        listLoading: false,
        page: 1,
        currentPage: 1,
        total: 0,
        filters: {
          companyId: '',
          groupId: '',
          type: null,
          state: null
        },
      }
    },
    filters: {
      filterType(type) {
        switch (type) {
          case 1:
            return '正常';
          case 2:
            return '预警';
          case 3:
            return '告警';
          case 4:
            return '故障';
        }
      },
    },
    methods: {
      formatDate: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      formatTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss');
      },
      formatDisposeTime: function (row, column) {
        if (!row.disposed) {
          return '未处理';
        }
        return moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.currentPage = this.page;
        this.getEvents();
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;
          //NProgress.done();
        });
      },
      updateState(index, row) {
        editState(row.id).then((res) => {
          //NProgress.done();
          this.$message({
            message: '处理成功',
            type: 'success'
          });
          this.getEvents();
        });
      },
      doSilent(index, row) {
        processSilent(row.id).then((res) => {
          //NProgress.done();
          this.$message({
            message: '处理成功',
            type: 'success'
          });
          row.silent = 1;
          this.getEvents();
        });
      },
      companyChange: function (val) {
        this.filters.groupId = '';
        this.getGroups(val);
      },
      getEvents() {
        let para = {
          page: this.page,
          size: 10,
          companyId: this.filters.companyId,
          groupId: this.filters.groupId,
          type: this.filters.type,
          state: this.filters.state,
        };
        this.listLoading = true;
        //NProgress.start();
        getEventList(para).then((res) => {
          this.total = res.data.total;
          this.events = res.data.list;
          this.listLoading = false;
          //NProgress.done();
        });
      },
    },
    mounted() {
      if (this.$route.query.type) {
        this.filters.type = parseInt(this.$route.query.type);
        this.filters.state = 0;
      }
      this.filters.companyId = (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN') ? '' : this.me.companyId;
      if (this.$route.query.companyId) {
        this.filters.companyId = this.$route.query.companyId;
      }

      this.getEvents();
      this.getCompanies();

      this.getGroups(this.filters.companyId);
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Event.vue?536d199a